import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import InlineCommentsFocusedInlineCommentQuery, {
	type InlineCommentsFocusedInlineCommentQuery$data,
	type InlineCommentsFocusedInlineCommentQuery$variables,
} from './view-mode/__generated__/InlineCommentsFocusedInlineCommentQuery.graphql.ts';

export function preloadFocusedInlineComment(
	commentId: string,
	contentId: string,
): Promise<{
	data: InlineCommentsFocusedInlineCommentQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<
		InlineCommentsFocusedInlineCommentQuery$data,
		InlineCommentsFocusedInlineCommentQuery$variables
	>({
		query: InlineCommentsFocusedInlineCommentQuery,
		variables: {
			commentId,
			contentId,
		},
	});
}
